import React, { useEffect, useState } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody, Label } from "reactstrap";
import error from "assets/images/error-img.png";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import DeleteModal from "components/Common/DeleteModal";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import Select from "react-select";
import Language from "Enums/Language";
import AdminsService from "services/Admin/AdminsService";
import RolesService from "services/Admin/RolesService";
import SalesRepsService from "services/Provider/SalesRepServices";
import FileUpload from "components/Common/file-upload/file-upload.component";
import CountriesService from "services/Admin/CountriesService";
import CompoundService from "services/SalesDeveloper/CompoundService";
import AreasService from "services/Admin/AreasService";

function ModalForm({
	media,
	modal,
	toggle,
	salesRep,
	phoneData = "",
	nameData = "",
	email,
	nameAr = "",
	compounds = "",
	area = "",
	setgetSalesData,
}) {
	const [uploadState, setUploadState] = useState(false);
	const [loading, setLoading] = useState(false);
	const [countriesOptions, setCountriesOptions] = useState([]);
	const [areasOptions, setAreasOptions] = useState([]);
	const [compoundsOptions, setCompoundsOptions] = useState([]);
	const [formState, setFormState] = useState({
		media_id: salesRep.media.id,
		media_id_path: "",
		name: nameData,
		phone: phoneData,
		name_ar: nameAr,
		media: [media],
		country: "",
		area: area,
		compounds: compounds,
	});
	const salesRepsService = new SalesRepsService();

	useEffect(() => {
		new CountriesService().getDropDown().then((res) => {
			const newOptions = res?.data?.map((item) => {
				return {
					label: item.name.en,
					value: item.id,
				};
			});
			setCountriesOptions(newOptions);
		});

		new CompoundService().getDropDown().then((res) => {
			const newOptions = res?.data?.map((item) => {
				return {
					label: item.name.en,
					value: item.id,
				};
			});
			setCompoundsOptions(newOptions);
		});
	}, []);

	useEffect(() => {
		if (!!formState?.country?.value) {
			new AreasService()
				.getAreasDropDown(formState?.country.value)
				.then((res) => {
					const data = res.data?.map((item) => {
						return {
							name: item.name,
							label: item.name.en,
							value: item.id,
						};
					});
					setAreasOptions(data);
				});
		}
	}, [formState?.country]);

	const handleFieldChange = (e) => {
		setFormState({ ...formState, [e.target.name]: e.target.value });
	};

	const updatedAttachment = (attachments, type) => {
		const mediaObj = {
			[`${type}`]: attachments[0]?.id,
			[`${type}_path`]: attachments[0]?.path,
		};
		setFormState({ ...formState, ...mediaObj });
	};

	// FILE UPLOAD
	const deleteAttachment = (_, type) => {
		const mediaObj = {
			[type]: null,
			[`${type}_path`]: null,
		};
		setFormState({ ...formState, ...mediaObj });
	};
	const handleValidSubmit = (e, values) => {
		setLoading(true);
		const data = {
			name: {
				ar: formState.name_ar,
				en: formState.name,
			},
			email: email,
			phone: formState.phone,
			media_id: formState.media_id,
			area_ids: [formState.area?.value],
			compound_ids: formState?.compounds?.map((res) => res?.value),
		};

		salesRepsService.update(data).then((res) => {
			if (res && res.status === SuccessOk) {
				setgetSalesData((c) => c + 1);
				toggle();
				toast.success("Personal data Updated Successfully");
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
			<ModalHeader className="border-0" toggle={toggle}>
				Edit Profile Information
			</ModalHeader>
			<ModalBody className="pt-0">
				<AvForm
					className="form-horizontal formWithLabel"
					onValidSubmit={(e, v) => {
						handleValidSubmit(e, v);
					}}>
					<Row>
						<Col md={12}>
							<FileUpload
								accept=".jpg,.png,.jpeg,.JPG,.PNG,.JPEG"
								label="Profile Picture"
								attachmentType="media_id"
								attachmentData={formState.media}
								setUpload={() => {}}
								updatedAttachment={updatedAttachment}
								deleteAttachment={deleteAttachment}
								setUploadState={setUploadState}
							/>
						</Col>
						<Col md={12}>
							<Label>Sales Rep Name (en)*</Label>
							<AvField
								className="mb-3 font-size-14"
								name="name"
								bsSize="lg"
								required
								placeholder="English"
								value={formState.name}
								onChange={(e) => handleFieldChange(e)}
							/>
						</Col>
						<Col md={12}>
							<Label>Sales Rep Name (ar)*</Label>
							<AvField
								className="mb-3 font-size-14"
								name="name_ar"
								bsSize="lg"
								required={false}
								placeholder="Arabic"
								value={formState.name_ar}
								onChange={(e) => handleFieldChange(e)}
							/>
						</Col>
						<Col md={12}>
							<Label>Phone</Label>
							<AvField
								className="mb-3 font-size-14"
								name="phone"
								bsSize="lg"
								required
								type="number"
								placeholder="Phone Number"
								value={formState.phone}
								onChange={(e) => handleFieldChange(e)}
							/>
						</Col>
						<Col md={12} className="mb-3">
							<label>Country</label>
							<Select
								placeholder={"Select"}
								options={countriesOptions}
								onChange={(data) => {
									setFormState({ ...formState, country: data });
								}}
								value={formState?.country}
							/>
						</Col>
						<Col md={12} className="mb-3">
							<label>Area</label>
							<Select
								placeholder={"Select"}
								options={areasOptions}
								onChange={(data) => {
									setFormState({ ...formState, area: data });
								}}
								value={formState?.area}
							/>
						</Col>
						<Col md={12}>
							<label>Compounds</label>
							<Select
								placeholder={"Select"}
								options={compoundsOptions}
								isMulti
								onChange={(data) => {
									setFormState({ ...formState, compounds: data });
								}}
								value={formState?.compounds}
							/>
						</Col>
					</Row>
					<Row className="p-0 pt-1 m-0 mt-2 d-flex justify-content-between">
						<Col md={6} className="p-0">
							<button
								type="button"
								onClick={toggle}
								className="btn btn-secondary w-50 ">
								Cancel
							</button>
						</Col>
						<Col md={6} className="p-0 d-flex justify-content-end">
							<button
								type="submit"
								disabled={uploadState ? true : loading ? true : false}
								className="btn btn-success w-50">
								Submit
							</button>
						</Col>
					</Row>
				</AvForm>
			</ModalBody>
		</Modal>
	);
}

export default ModalForm;
